import { type MutationOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ReqAddTaskActionMutation, type ReqDeleteTaskActionMutation } from './types'

export const addTaskActionMutation: MutationOptions<null, unknown, ReqAddTaskActionMutation> = {
  mutationFn: ({ taskId, ...rest }) => w.post(rest, API_ENDPOINTS.business.v1.task.action.index(taskId)).json(),
}

export const deleteTaskActionMutation: MutationOptions<null, unknown, ReqDeleteTaskActionMutation> = {
  mutationFn: ({ taskId, actionId }) =>
    w.delete(API_ENDPOINTS.business.v1.task.action.actionId.index(taskId, actionId)).json(),
}
